import { render, staticRenderFns } from "./integral_pay.vue?vue&type=template&id=253fca36&"
import script from "./integral_pay.vue?vue&type=script&lang=js&"
export * from "./integral_pay.vue?vue&type=script&lang=js&"
import style0 from "./integral_pay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports